<script>
    import clientDetailActions from './actions.vue';
    import clientDetailPlaylog from './playlog.vue';
    import clientDetailStatus from './status.vue';
    import clientDetailSystemlog from './systemlog.vue';

    export default {
        components: {
            clientDetailActions,
            clientDetailPlaylog,
            clientDetailStatus,
            clientDetailSystemlog
        }
    }
</script>